import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	ForgotPasswordRecoverUserInfo,
	ForgotPasswordRecoverUserInfoModel,
	ForgotPasswordRecoverUserInfoParams,
} from 'domain/usecases';

export class RemoteForgotPasswordRecoverUserInfo implements ForgotPasswordRecoverUserInfo {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ForgotPasswordRecoverUserInfoModel>,
	) {}

	async forgotPasswordRecoverUserInfo({
		signal,
		...bodyParams
	}: ForgotPasswordRecoverUserInfoParams): Promise<ForgotPasswordRecoverUserInfoModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: bodyParams,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
